export enum SnackBarTypes {
  simple = 'simple',
  success = 'success',
  failure = 'failure',
  loading = 'loading',
}

export interface SnackBarContextType {
  isOpen: boolean
  text: string
  type?: SnackBarTypes | null
  isDismissible?: boolean
  isAutoDismissible?: boolean
  action?: SnackBarAction
  openSnackBar: (params: OpenSnackBarParams) => void
  closeSnackBar: () => void
  clearSnackBarState: () => void
  bottom?: SnackBarPosition
}

export interface SnackBarAction {
  onClick?: () => void
  text?: string
}

export interface SnackBarPosition {
  phone?: number
  desktop?: number
}

export interface SnackBarContextProviderProps {
  children: React.ReactNode
}

export interface OpenSnackBarParams {
  text: string
  type?: SnackBarTypes
  isDismissible?: boolean
  isAutoDismissible?: boolean
  action?: SnackBarAction
  autoDismissTime?: number
  bottom?: SnackBarPosition
}
